const information = {
  title: 'Informació d\'expedients',
};

export default information;
